/**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el = $(el);
const $btnOpenModal = $body.find('[data-modal]');

const $overlay     = $el.find('.overlay');
const $btnCancel   = $el.find('.button-cancel');
const $btnFechar   = $el.find('.btn-fechar');
const $comiteField = $el.find('.comite-field');
const $comiteInput = $comiteField.find('input');
const $visibleContent = $('.visible-content');

let $fromButton;

$el.on('modal:open', function(e, fromButton) {
    $fromButton = fromButton;

    $body.addClass('modal-opened');

    $el.addClass('active');
    trapFocus($el);
    $btnOpenModal.attr('aria-hidden', 'true');
    $visibleContent.attr('aria-hidden', 'true');

    $el.attr({
        'aria-hidden': 'false',
        'open': 'true',
        'tabindex': '0'
    });
});

$("#hasComite").on('change', function() {
    if(this.checked) {
        $comiteField.removeClass('disabled-field');
        $comiteInput.removeAttr('disabled');
    } else {
        $comiteField.addClass('disabled-field');
        $comiteInput.attr('disabled', 'true');
    }
});

// Modal Hide
$btnCancel.add($btnFechar).add($overlay).on('click', function(e) {
    e.preventDefault();
    $el.trigger('modal:close');
});

$el.on('keyup', function(e){
    if (e.keyCode === 27 ) {
        $el.trigger('modal:close');
    };
});

$el.on('modal:close', function() {
    $body.removeClass('modal-opened');
    $el.removeClass('active');

    $fromButton.focus();

    $btnOpenModal.attr('aria-hidden', 'false');
    $el.attr('aria-hidden', 'true');
    $el.removeAttr('open tabindex');
    $visibleContent.attr('aria-hidden', 'false');
});
